'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
// 支持的事件
var supportEventList = exports.supportEventList = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick'];

// 获取操作事件map
var getSupportEventMap = exports.getSupportEventMap = function getSupportEventMap() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var result = {};

    supportEventList.map(function (item) {
        if (item && typeof data[item] !== 'undefined') {
            result[item] = data[item];
        }
        return item;
    });

    return result;
};

exports.default = {
    supportEventList: supportEventList,
    getSupportEventMap: getSupportEventMap
};